import { render, staticRenderFns } from "./surface_container.vue?vue&type=template&id=43d8708c&scoped=true&"
import script from "./surface_container.vue?vue&type=script&lang=ts&"
export * from "./surface_container.vue?vue&type=script&lang=ts&"
import style0 from "./surface_container.vue?vue&type=style&index=0&id=43d8708c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d8708c",
  null
  
)

export default component.exports